import { memo } from 'react';

import type { LbPart } from '../../types';

const FormGuide = ({ data }) => <div className='lb-composer-wrap' dangerouslySetInnerHTML={{ __html: data.Text }} />;

const MatchInfo = ({ data }) => <div className='lb-composer-wrap' dangerouslySetInnerHTML={{ __html: data.Text }} />;

const Head2Head = ({ data }) => <div className='lb-composer-wrap' dangerouslySetInnerHTML={{ __html: data.Text }} />;

const Lineup = ({ data }) => <div className='lb-composer-wrap' dangerouslySetInnerHTML={{ __html: data.Text }} />;

const MatchSummary = ({ part: { data } }: { part: LbPart }) => (
  <>
    {data.Type === 'FORM_GUIDE' && <FormGuide data={data} />}
    {data.Type === 'MATCH_INFO' && <MatchInfo data={data} />}
    {data.Type === 'HEAD_TO_HEAD' && <Head2Head data={data} />}
    {data.Type === 'LINE_UP' && <Lineup data={data} />}
  </>
);

export default memo(MatchSummary);
